import EditRouteTask from "./EditRouteTask"

export default  EditRouteTask;



// WEBPACK FOOTER //
// ./src/components/App/RouteTaskDashboard/RouteTaskTable/EditRouteTask/index.js